/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationDefinitions {
    getFixupPrototypeFunction() { return RecommendationDefinitions.fixupPrototype; }

    static newInstance(model: Partial<RecommendationDefinitions>): RecommendationDefinitions {
        let obj = Object.assign(new RecommendationDefinitions(), model);
        RecommendationDefinitions.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationDefinitions>): RecommendationDefinitions {
        if (!model) return null;
        return RecommendationDefinitions.newInstance(<RecommendationDefinitions> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationDefinitions) {
        if (!obj) return;

        models.RecommendationDefinitions.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationDefinitions): boolean {
        Object.setPrototypeOf(obj, RecommendationDefinitions.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.recommendation_actions) {
            for (let val of this.recommendation_actions) {
                models.RecommendationActionsBase.fixupPrototype(val);
            }
        }
        if (this.resolution_validators) {
            for (let val of this.resolution_validators) {
                models.RecommendationResolutionBase.fixupPrototype(val);
            }
        }
        if (this.additional_resource_details_mapper) {
            for (let val of this.additional_resource_details_mapper) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the recommendation definition
     */
    name: string;

    /**
     * description of the recommendation definition
     */
    description: string;

    /**
     * Sys id of the recommendation definition
     */
    definition_sys_id: string;

    /**
     * Id from the cloud provider which needs to be called
     */
    api_reference_id: string;

    /**
     * service resource uri of the recommendation definition
     */
    service_resource_uri: string;

    /**
     * Classification of the policy
     */
    classification: models.PolicyClassification;

    /**
     * Indicates the sub classification for the policy
     */
    sub_classification: models.PolicySubClassificationV2;

    /**
     * Recommendation source V2
     */
    source: models.RecommendationSourceV2;

    /**
     * Indicates the group for the resource recommendation
     */
    recommendation_group: models.RecommendationGroupMapping;

    /**
     * Impact of the policy resource recommendation
     */
    impact: models.PolicyResourceRecommendationImpact;

    recommendation_actions: Array<models.RecommendationActionsBase>;

    /**
     * The provided key will be used to parse the current sku value from the resource details
     */
    key_for_sku: string;

    resolution_validators: Array<models.RecommendationResolutionBase>;

    /**
     * List of tag key/value pairs
     */
    additional_resource_details_mapper: Array<models.KeyValuePair>;

}
